export class LoginConfig {
    logo: string;
    repLogo: string;
    jirehLogo: string;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/loginConfig.ts